import { createSelector } from 'reselect';
import { getAllModules } from './modules';
import { getLayout } from './layout';
export const getZones = (state, gruser)=>{
    var _getLayout;
    return ((_getLayout = getLayout(state, gruser)) === null || _getLayout === void 0 ? void 0 : _getLayout.zones) || {};
};
export const getZone = createSelector(getZones, (_, gruser, zoneName)=>zoneName, (zones, zoneName)=>zones === null || zones === void 0 ? void 0 : zones[zoneName]);
export const getZoneModules = (state, gruser, zoneName)=>{
    const zone = getZone(state, gruser, zoneName);
    const modules = getAllModules(state, gruser);
    if (!zone || !modules) {
        return [];
    }
    return zone.installedModulesIds.map((id)=>modules[id]).filter(Boolean);
};
export const getInstallableModules = (state, gruser, zoneName)=>{
    const zone = getZone(state, gruser, zoneName);
    if (!zone) {
        return [];
    }
    return zone.installableModuleTypes || [];
};
